import type { ICampaign } from "../../../../types/models/campaign.models.types";
import type { IPagination } from "../../../../types/models/pagination.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  campaigns: Array<ICampaign>;
  status: string;
  pagination: IPagination;
}

export function useGetCampaignsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns",
  });
}
